import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbc2b92c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tag-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }

import { ref, computed, PropType } from 'vue';

type CommonTitleType = {
    key: string;
    name: string;
    checked?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'common-title-list',
  props: {
    showMore: {
        type: Boolean,
        default: true,
    },
    tagList: {
        type: Array as PropType<Array<CommonTitleType>>,
        default: () => {
            return [];
        },
    },
    titleSize: {
        type: String,
        default: '18px',
    },
    hoverColor: {
        type: String,
        default: '#2164c9',
    },
    titleColor: {
        type: String,
        default: '#333',
    },
    titleFontWeight: {
        type: String,
        default: 'bold',
    },
    moreText: {
        type: String,
        default: '更多',
    },
},
  emits: ['goMore', 'changeTag'],
  setup(__props, { emit }) {

const props = __props;



const realList = computed(() => {
    return props.tagList.map(item => {
        return {
            ...item,
            checked: item.checked || false,
        };
    });
});



const curTag = ref<string>(realList.value[0]?.key || '');

const getStyle = computed(() => {
    return `
    --title-size: ${props.titleSize};
    --hover-color: ${props.hoverColor};
    --title-color: ${props.titleColor};
    --title-font-weight: ${props.titleFontWeight};
    `;
});

const goMore = () => {
    emit('goMore');
};

const changeTag = key => {
    curTag.value = key;
    emit('changeTag', curTag.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "common-title-box",
    style: _normalizeStyle(_unref(getStyle))
  }, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(realList), (item) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass([{ active: curTag.value === item.key }]),
          key: item.key,
          onClick: ($event: any) => (changeTag(item.key))
        }, _toDisplayString(item.name), 11, _hoisted_2))
      }), 128))
    ]),
    _renderSlot(_ctx.$slots, "default"),
    (props.showMore)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("a", {
            class: "more",
            onClick: goMore,
            href: "javascript:;"
          }, _toDisplayString(__props.moreText) + " >", 1)
        ]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})